<div class="w-full md:w-10/12 mx-auto py-4">
    <form [formGroup]="formControl" class="">

        <div class="w-full flex justify-end">
            <mat-form-field class="fuse-mat-dense">
                <mat-select [value]="idGestion" formControlName="tipoTarea">
                  <mat-option [value]="idGestion">Gestión</mat-option>
                </mat-select>
            </mat-form-field>              
        </div>

        <mat-form-field
            class="w-full fuse-mat-dense">
            <mat-label>Nombre</mat-label>
            <input matInput type="text" formControlName="nombreGestion" id="fullName" name="fullName" required />
        </mat-form-field>

        <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Descripción</mat-label>
            <textarea matInput rows="3" formControlName="descripcion"></textarea>
        </mat-form-field>

        <div class="grid w-full min-w-0 grid-cols-1 gap-x-2 md:grid-cols-2">
            <mat-form-field  class="w-full fuse-mat-dense mb-0">
                <mat-label>Asignado A</mat-label>
                <mat-select matNativeControl required formControlName="usuarioAsignado">
                    @for (usuario of usuariosList; track $index){
                        <mat-option [value]="usuario.usuarioId">{{usuario.nombreCompleto}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
                
            <mat-form-field  class="w-full fuse-mat-dense">
                    <mat-label>Prioridad</mat-label>
                    <mat-select matNativeControl required formControlName="prioridad">
                        @for (prioridad of prioridades; track prioridad.tipologiaId){
                            <mat-option [value]="prioridad.tipologiaId">{{prioridad.descripcion}}</mat-option>
                        }
                </mat-select>
            </mat-form-field>

            <mat-form-field  class="w-full fuse-mat-dense">
                <mat-label>Origen</mat-label>
                <mat-select matNativeControl formControlName="origen" required>
                    @for (origen of origenList; track origen.tipologiaId){
                        @if(origen.tipologiaId != tipologiaIdOrigenTareaVA){
                            <mat-option [value]="origen.tipologiaId">{{origen.descripcion}}</mat-option>
                        }
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field  class="w-full fuse-mat-dense">
                <mat-label>Sección</mat-label>
                <mat-select matNativeControl formControlName="seccion" required>
                    @for (seccion of seccionesLis; track seccion.tipologiaId){
                        <mat-option [value]="seccion.tipologiaId">{{seccion.descripcion}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field
            class="w-full fuse-mat-dense">
            <mat-label>Nombre/Correo del solicitante</mat-label>
            <input matInput type="text" formControlName="solicitante" id="solicitante" name="solicitante" required />
        </mat-form-field>

        <mat-form-field  class="w-full fuse-mat-dense">
                <mat-label>Clasificación</mat-label>
                <mat-select matNativeControl required formControlName="clasificacion">
                    @for (clasificacion of clasificaciones; track clasificacion.tipologiaId){
                        <mat-option [value]="clasificacion.tipologiaId">{{clasificacion.valor2? clasificacion.valor2:clasificacion.descripcion}}</mat-option>
                    }
            </mat-select>
        </mat-form-field>        
  
    </form>
  
    <div class="w-full flex justify-end mt-3">

        <button mat-fab class="rounded-md w-32 h-12 mr-4"
            [color]="'secondary'"
            (click)="onClose()">
            Cerrar
        </button>
  
      <button mat-fab class="rounded-md w-32 h-12"
        (click)="postGestion()"
        [color]="'primary'" 
        [disabled]="!this.formControl.valid">
        Crear Gestión
      </button>
    </div>
  </div>